export const UserTypes = {
    STYLIST: "stylist",
    CLIENT: "client",
};

export const RequestTypes = {
    ACCEPTED: "accepted",
    REJECTED: "rejected",
};

export const AnalyticsFlow = {
    SHOPPABLE: "shoppable",
    RECOMMEND: "recommend",
    CHAT: "chat",
    REGULAR: "regular",
    SALES: "social_share",
    STYLIST_PURCHASE: "stylist_purchase",
};

export const Actions = {
    VIEW: "view",
    VIDEO_VIEW: "video_view",
    ATC: "atc",
    RECOMMEND: "recommended",
};

export const Sources = {
    HOME: "home",
    SHOPPABLE: "shoppable",
    STORY: "editorial",
    CLIENT_DETAILS: "client_profile",
    CLOSETS: "closet",
    OUTFIT: "outfits",
    FAVOURITES: "favorites",
    SEARCH: "search",
    AI_CHAT: "aiChat",
    NOTIFICATION: "notification",
    CHECKOUT: "cart",
    REORDER: "reorder",
    ORDER_SUMMARY: "order_summary",
    CATEGORY: "category",
    CHAT: "chat",
    CLOSET_DIGI: "closet_digitisation",
    DEEPLINK: "deeplink",
    ORDER_HISTORY: "orderHistory",
    ORDER_DETAILS: "orderDetails",
};

export const OutfitType = {
    RECOMMEND: "Recommended",
    MY_OOUTFIT: "My Outfit",
};

export const ClosetType = {
    RECOMMEND: "Recommended",
    MY_CLOSET: "My Closet",
};

export const ShareModalType = {
    OUTFIT_LIST: "outfitList",
    CLOSET_LIST: "closetList",
    OUTFIT_DETAIL: "outfitDetails",
    CLOSET_DETAIL: "closetDetails",
    VIDEO_ID: "videoId",
};

export const AsyncStorageKeys = {
    IS_DONT_SHOW_AGAIN: "isDontShowAgain",
    IS_SHOW_LOTTIE_CLOSET: "isShowLottieCloset",
    IS_SHOW_LOTTIE_OUTFIT: "isShowLottieOutfit",
    IS_BIOMETRIC_ENABLED: "isBiometricEnabled",
    USER_ID: "userId",
    SESSION_ID: "sessionId",
};

export const ClosetModalType = {
    MANUAL: "manual",
    MOVE: "move",
    MOVE_MULTIPLE: "moveMultiple",
    CREATE_OUTFIT: "createOutfit",
};
